import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import PageVideoGalleryList from '../../PageVideoGalleryList';
import PageSectionHeading from '../../PageSectionHeading';
// import { colors } from '../styles';

const styles = css`
  padding: 45px 0;
  @media (min-width: 992px) {
    padding: 90px 0;
  }
`;


function PageVideoGallery({ content }) {
  return (
    <section className={styles}>
      <PageSectionHeading h3={get(content, '[0].section_heading')} />
      {
        get(content, '[0].videos', []).length > 0 &&
        <div className="container">
          <PageVideoGalleryList
            videoCollection={get(content, '[0].videos')}
          />
        </div>
      }
    </section>
  );
}

PageVideoGallery.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default PageVideoGallery;



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/PageVideoGallery.section.js